import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Document } from '@contentful/rich-text-types'
import { IRichTextReference } from '@src/quince-site-common/src/domains/RichText'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import useDynamicStyle from '@src/quince-site-common/src/hooks/useDynamicStyle'
import classNames from 'classnames'
import { CSSProperties } from 'react'

import { options } from './richText.helpers'
import styles from './richText.module.scss'

export interface RichTextProps {
  content?: Document
  references?: IRichTextReference[]
  className?: string
  wrapperStyles?: CSSProperties
  mobileClassNames?: string[]
  desktopClassNames?: string[]
  commonClassNames?: string[]
  dynamicValueClassesMobile?: string[]
  baseDynamicValueClasses?: string[]
}
export const RichText = ({
  baseDynamicValueClasses,
  dynamicValueClassesMobile,
  className: classNameFromProps = '',
  ...props
}: RichTextProps) => {
  const { className, styleObject } = useDynamicStyle({
    baseClassNames: props.commonClassNames,
    mobileClassNamesOverride: props.mobileClassNames,
    dynamicValueClassesMobileOverride: dynamicValueClassesMobile,
    baseDynamicValueClasses: baseDynamicValueClasses,
    // @i18n-ignore
    postFix: 'rich-text',
  })
  const deviceInfo = useDeviceInfo()

  if (!props.content) return null

  return (
    <>
      {deviceInfo.deviceType === DEVICE_TYPES.MOBILE && (
        <div
          className={classNames(className, styles.wrapper, classNameFromProps, 'mobileOnly')}
          style={{ ...(props.wrapperStyles || {}), ...styleObject }}
        >
          {documentToReactComponents(props.content, options)}
        </div>
      )}
      {deviceInfo.deviceType === DEVICE_TYPES.DESKTOP && (
        <div
          style={{ ...(props.wrapperStyles || {}), ...styleObject }}
          className={classNames(props.commonClassNames?.join(' '), styles.wrapper, classNameFromProps, 'desktopOnly')}
        >
          {documentToReactComponents(props.content, options)}
        </div>
      )}
    </>
  )
}

export default RichText
